<template>
  <BContainer
    class="p-0"
    fluid
  >
    <ValidationObserver
      ref="user"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="First Name"
              label-for="fFirstName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fFirstName"
                v-model="formUser.first_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Last Name"
              label-for="fLastName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fLastName"
                v-model="formUser.last_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol cols="12" />

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Mobile Number"
              label-for="fMobileNumber"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fMobileNumber"
                v-model="formUser.mobile_number"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Email"
              label-for="fEmail"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fEmail"
                v-model="formUser.email"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <ValidationProvider
              v-slot="{ errors }"
              name="username"
              vid="username"
              rules="required|max:50"
            >
              <BFormGroup
                label="Username"
                label-for="username"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="username"
                  v-model="formUser.username"
                  disabled
                />
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Notification Email"
              label-for="fNotificationEmail"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fNotificationEmail"
                v-model="formUser.notification_email"
                disabled
              />
            </BFormGroup>
          </BCol>

        </BRow>
      </form>
    </ValidationObserver>
  </BContainer>
</template>
<script>
import MxMisc from '@/mixins/misc'
import MClusters from '@/mixins/locations/clusters'

export default {
  name: 'VOfficerInformations',

  mixins: [
    MClusters,
    MxMisc
  ],

  props: {
    user: {
      type: Object,
      default: () => ({
        id: '',
        username: '',
        name: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        email: '',
        notification_email: '',
        role: '',
        role_name: '',
        area: '',
        provinces: [],
        photo_url: ''
      })
    }
  },

  emits: ['updated'],

  data () {
    return {
      formUser: {
        username: this.user.username,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        mobile_number: this.user.mobile_number,
        email: this.user.email,
        notification_email: this.user.notification_email
      }
    }
  }
}
</script>
